import React, {useContext} from 'react';
import {useTranslation} from "react-i18next";
import SidebarNavigationButton from "../../../components/SidebarNavigationButton/SidebarNavigationButton";
import {useAppSelector} from "../../../../../../app/store";
import {selectCurrentUser} from "../../../../../../features/authentication/authenticationSliceSelectors";
import {UserRole} from "../../../../../../app/enums/UserRole";
import {getUserRole} from "../../../../../../helpers/user";
import SidebarNavigationNestedButton
    from "../../../components/SidebarNavigationButton/SidebarNavigationNestedButton/SidebarNavigationNestedButton";
import {SidebarContext} from "../../../Sidebar";
import {isMobile} from "react-device-detect";

type SidebarMenuSupplierGeographyProps = {
    expandedId: string;
    onClick?: (id: string) => void;
};

const SidebarMenuSupplierGeography: React.FC<SidebarMenuSupplierGeographyProps> = ({
                                                                  expandedId,
                                                                  onClick: onClickProp,
                                                              }) => {
    const {t} = useTranslation();
    const user = useAppSelector(selectCurrentUser);

    const {
        expanded,
        hoverExpanded,
        setIsExpandedOnHover
    } = useContext(SidebarContext);

    const handleNavigationClick = (id: string) => {
        if (onClickProp) {
            onClickProp(id);
        }
    };

    const handleNestedNavigationClick = () => {
        if (isMobile && !expanded && hoverExpanded) {
            setIsExpandedOnHover(false);
        }
    }

    if (!user) {
        return null;
    }

    let role = getUserRole(user);

    if (role !== UserRole.Administrator &&
        role !== UserRole.Forwarder) {
        return null;
    }

    return (
        <SidebarNavigationButton id={'sidebar-supplier-geography'} 
                                expandedId={expandedId}
                                 type={'primary'} 
                                 onClick={handleNavigationClick}
                                 text={t("sidebar.supplier-geography.main-page")}
                                 title={t("sidebar.supplier-geography.main-page")}
                                 path={'/supplierGeography'}
                                 icon={"faCubeApproved"}
                                 //activeWhenAdditionalPath={['/disposition', '/invoices']}
                                 >

            <SidebarNavigationNestedButton id={'sidebar-supplier-geography-item'}
                                           type={'primary'}
                                           path={'/supplierGeography/main'}
                                           text={t("sidebar.supplier-geography.main-page")}
                                           title={t("sidebar.supplier-geography.main-page")}
                                           tooltip={t("sidebar.supplier-geography.main-page") || ''}
                                           onClick={handleNestedNavigationClick}/> 

            <SidebarNavigationNestedButton id={'sidebar-supplier-geography-email-logs'}
                                           type={'primary'}
                                           path={'/supplierGeography/emailLogs'}
                                           text={t("sidebar.supplier-geography.email-logs")}
                                           title={t("sidebar.supplier-geography.email-logs")}
                                           tooltip={t("sidebar.supplier-geography.email-logs-tooltip") || ''}
                                           onClick={handleNestedNavigationClick}/> 
            
        </SidebarNavigationButton>
    );
};

export default SidebarMenuSupplierGeography;
